"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHMenuEntryV3 = exports.KHMenuGenericEntryV3 = void 0;
const KHEventHandler_1 = require("../../KHEventHandler");
/**
 * Class to subclass if you want to customize the event map.
 */
class KHMenuGenericEntryV3 extends KHEventHandler_1.KHEventHandler {
    constructor(config) {
        super();
        this.locked = false;
        this.config = config;
        this.extras = config.extras;
    }
    static JustText(text, extras) {
        return new KHMenuGenericEntryV3({
            text,
            selectable: false,
            extras
        });
    }
    static Spacer() {
        return new KHMenuGenericEntryV3({ selectable: false });
    }
    getIsSelectable() {
        return this.config.selectable;
    }
    setIsSelectable(selectable) {
        this.config.selectable = selectable;
        this.narrowedEmitter().emitEvent("is_selectable_updated", { selectable });
    }
    getIsSelected() {
        return this.selected;
    }
    setIsSelected(selected) {
        this.selected = selected;
        this.narrowedEmitter().emitEvent("is_selected_updated", { selected });
    }
    getText() {
        return this.config.text;
    }
    setText(text) {
        this.config.text = text;
        this.narrowedEmitter().emitEvent('text_updated', { text });
    }
    getDescription() {
        return this.config.description;
    }
    setDescription(text) {
        this.config.description = text;
        this.narrowedEmitter().emitEvent('description_updated', { text });
    }
    getLocked() {
        return this.locked;
    }
    setLocked(locked) {
        this.locked = locked;
        this.narrowedEmitter().emitEvent('is_locked_updated', { locked });
    }
    narrowedEmitter() {
        return this;
    }
}
exports.KHMenuGenericEntryV3 = KHMenuGenericEntryV3;
class KHMenuEntryV3 extends KHMenuGenericEntryV3 {
}
exports.KHMenuEntryV3 = KHMenuEntryV3;
